import _Vue from "vue";

export class MetaStore{
    defaultTitle: string 
    constructor(defaultTitle:string) {       
        this.defaultTitle = defaultTitle;
    }
    setDefaultTitle(){
        document.title = this.defaultTitle;
    }
    // setTitle(title?: string, append: boolean = true){
    //     this.setTitle(new String(title),append);
    // }
    setTitle(title: String?, append: boolean = true){
        if(append)
            document.title = title + ' | '+ this.defaultTitle
        else
            document.title = title;
    }
}



export default {
    install(Vue: typeof _Vue, defaultTitle: string) {
        const meta = new MetaStore(defaultTitle);
        Vue.prototype.$meta = meta;
        (Vue as any).$meta = meta;
      }
}